import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { PopperWrapper } from "./PopperWrapper";
import ToolButton, { Props as ToolButtonProps } from "./ToolButton";

export interface Props extends Omit<ToolButtonProps, "onClick" | "innerRef"> {
	popupContent(close: () => void): React.ReactElement;
}

const POPUP_SPACING: [number, number] = [0, 3];

const sneakyHolderStyles = { display: "flex" } as const;

export default function PopupToolButton(props: Props) {
	const focusHolder = useRef<HTMLDivElement | null>(null);
	const ref = useRef<HTMLButtonElement | null>(null);
	const [popupOpen, changePopupOpen] = useState(false);

	const { popupContent, ...childProps } = props;

	useEffect(() => {
		function handler(ev: FocusEvent) {
			const elt = focusHolder.current;
			const other = ev.relatedTarget as Node | null;
			if (elt) {
				if (!elt.contains(other)) {
					changePopupOpen(false);
				}
			}
		}
		document.addEventListener("blur", handler, { capture: true, passive: true });
		return () => document.removeEventListener("blur", handler, { capture: true });
	}, []);

	return (
		<div ref={focusHolder} style={sneakyHolderStyles}>
			<ToolButton
				{...childProps}
				onClick={() => changePopupOpen(!popupOpen)}
				innerRef={ref as React.RefObject<HTMLButtonElement>}
			/>
			{popupOpen && (
				<PopperWrapper placement="top" anchor={ref.current!} offset={POPUP_SPACING}>
					{popupContent(() => changePopupOpen(false))}
				</PopperWrapper>
			)}
		</div>
	);
}
